var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { attrs: { id: "changelog" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "changelog-header" }, [
            _c("div", { staticClass: "changelog-tabs" }, [
              _c(
                "div",
                {
                  staticClass: "changelog-tab",
                  class: { active: _vm.activePlatform === "android" },
                  on: {
                    click: function ($event) {
                      return _vm.switchPlatform("android")
                    },
                  },
                },
                [_vm._v("\n              安卓端更新\n            ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "changelog-tab",
                  class: { active: _vm.activePlatform === "ios" },
                  on: {
                    click: function ($event) {
                      return _vm.switchPlatform("ios")
                    },
                  },
                },
                [_vm._v("\n              苹果端更新\n            ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "changelog-timeline" },
            _vm._l(_vm.changelogsByYear, function (yearGroup, yearIndex) {
              return _c(
                "div",
                { key: yearGroup.year, staticClass: "changelog-year-group" },
                [
                  yearGroup.year != new Date().getFullYear()
                    ? _c(
                        "div",
                        { staticClass: "changelog-year-title changelog-item" },
                        [
                          _c("div", { staticClass: "changelog-date" }, [
                            _vm._v(_vm._s(yearGroup.year)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "changelog-content" }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(yearGroup.items, function (item, itemIndex) {
                    return _c(
                      "div",
                      {
                        key: `${yearGroup.year}-${itemIndex}`,
                        staticClass: "changelog-item",
                        class: { active: yearIndex === 0 && itemIndex === 0 },
                      },
                      [
                        _c("div", { staticClass: "changelog-date" }, [
                          _vm._v(_vm._s(_vm.formatDate(item.update_date))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "changelog-content" }, [
                          _c("div", { staticClass: "changelog-version" }, [
                            _vm._v("版本：" + _vm._s(item.version)),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "changelog-list" }, [
                            _c("li", {
                              domProps: { innerHTML: _vm._s(item.content) },
                            }),
                          ]),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "changelog-footer" }, [
            _vm.hasMoreData
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-light",
                    on: { click: _vm.loadMoreVersions },
                  },
                  [_vm._v("\n            查看更多版本\n          ")]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.hasMoreData
              ? _c(
                  "div",
                  {
                    staticClass: "no-more-data",
                    staticStyle: {
                      "font-size": ".7rem",
                      "text-align": "center",
                      color: "#ccc",
                      "margin-top": "1rem",
                    },
                  },
                  [_vm._v("\n            暂无更多\n          ")]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "changelog-header-box" }, [
      _c("div", { staticClass: "box-info" }, [
        _c("h2", [_vm._v("39游戏盒子")]),
        _vm._v(" "),
        _c("p", [_vm._v("您的游戏库和随身礼包助手")]),
        _vm._v(" "),
        _c("p", [_vm._v("提供官方资讯、社区交友、周边商城、云手机等功能")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "download-btn",
            attrs: {
              href: "https://bbsnewapi.3975bbs.com/common/packageAppLink?advertisingId=351",
              target: "_blank",
            },
          },
          [_vm._v("下载最新版本")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }